import { createClientFetcher } from '@subtile/project-shared';

export default createClientFetcher({
  httpUrl: import.meta.env.VITE_FINANCE_API_URL,
  wsUrl: ''
});
